'use client';
import { Button, CircularProgress } from '@mui/material';
import { useTranslations } from 'next-intl';
import { useCart, useSimpleMutation } from '@peerless/ui-shared';

interface Props {
  sku: string;
  accessorySku?: string;
  productTitle: string;
  imageUrl?: string;
  price: number;
}

export const AddToCartButton: React.FC<Props> = ({
  sku,
  accessorySku,
  productTitle,
  imageUrl,
  price,
}: Props) => {
  const t = useTranslations();
  const { addProductToCart } = useCart();

  const { mutate, isPending } = useSimpleMutation(addProductToCart, [sku, accessorySku]);

  const handleAddToCart = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const skus = accessorySku ? [sku, accessorySku] : [sku];

    // Data layer push
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        items: [
          {
            item_id: sku,
            item_name: productTitle,
            price: price,
            image_url: imageUrl,
            quantity: 1,
            currency: 'USD',
          },
        ],
      },
    });

    mutate(skus);
  };

  return (
    <Button fullWidth variant="outlined" onClick={handleAddToCart} className="add_to_cart_button">
      {isPending ? <CircularProgress size={24} /> : t('Cart.add-to-cart')}
    </Button>
  );
};
